





























import { Vue, Component, Prop } from "vue-property-decorator";

import { Product } from "../../../../../components/Shop/Products/types";
import PostApi from "../../../../../plugins/AdminTemplate/includes/logic/Api/PostApi";
import { PayedPostMessage } from "../../types";

@Component({})
export default class PaidPostTypePreview extends Vue {
  @Prop() message!: PayedPostMessage

  @Prop() targetToUpload!: string

  @Prop() products!: Array<Product>

  get product(): Product | null {
    return this.products?.find(p => p.id === this.message.product_id) ?? null
  }

  get imageLink():string {
    return `${ PostApi.getRequestUrl('tg', 'getproductimage') }?target=${ encodeURI(this.targetToUpload) }&amp;file_descriptor=${ this.product?.image }`
  }
}
